// src/utils/severeWeatherFlag.js
// Sets/clears the localStorage flag that triggers the weather disclaimer
// on next app open. Called by the alert store when alerts change.

export function setSevereWeatherFlag(hasActiveAlerts) {
  try {
    if (hasActiveAlerts) {
      localStorage.setItem('eos-active-severe-weather', '1');
    } else {
      localStorage.removeItem('eos-active-severe-weather');
    }
  } catch {}
}

export function isSevereWeatherFlagSet() {
  try { return localStorage.getItem('eos-active-severe-weather') === '1'; }
  catch { return false; }
}
